import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { AppConfig, CMPS_APP_CONFIG } from '../../../app.config';
import { ModelSetTransformer } from '../../../common/common.model';
import {
    AreaItem,
    AreaItemModelSetTransformer,
} from '../model/population/area.model';
import {
    LobItem,
    LobItemModelSetTransformer,
} from '../model/population/lob.model';
import {
    PeerGroupItem,
    PeerGroupItemModelSetTransformer,
} from '../model/population/peergroup.model';
import { PopulationGroup } from '../model/population/population-group.model';
import {
    RegionItem,
    RegionItemModelSetTransformer,
} from '../model/population/region.model';
import {
    RoleItem,
    RoleItemModelSetTransformer,
} from '../model/population/role.model';
import {
    SiteItem,
    SiteItemModelSetTransformer,
} from '../model/population/site.model';
import {
    SuperGroupItem,
    SuperGroupItemModelSetTransformer,
} from '../model/population/supergroup.model';

@Injectable()
export class PopulationService {
    constructor(
        private readonly _http: HttpClient,
        @Inject(CMPS_APP_CONFIG) private readonly _appConfig: AppConfig,
    ) {}

    private _list<T, U>(
        which: string,
        Transformer: new () => ModelSetTransformer<T, U>,
    ): Observable<T[]> {
        return this._http
            .get(`${this._appConfig.API_ENDPOINTS.USER}/population/${which}`)
            .pipe(
                map((model) => new Transformer().transform(model as U[])),
                catchError((error) => {
                    console.error(error);
                    throw new Error(`${which} failed`);
                }),
            );
    }

    listLobs(): Observable<LobItem[]> {
        return this._list('lobs', LobItemModelSetTransformer);
    }

    listRegions(): Observable<RegionItem[]> {
        return this._list('regions', RegionItemModelSetTransformer);
    }

    listAreas(): Observable<AreaItem[]> {
        return this._list('areas', AreaItemModelSetTransformer);
    }

    listSites(): Observable<SiteItem[]> {
        return this._list('sites', SiteItemModelSetTransformer);
    }

    listSuperGroups(): Observable<SuperGroupItem[]> {
        return this._list('supergroups', SuperGroupItemModelSetTransformer);
    }

    listPeerGroups(): Observable<PeerGroupItem[]> {
        return this._list('peergroups', PeerGroupItemModelSetTransformer);
    }

    listRoles(): Observable<RoleItem[]> {
        return this._list('roles', RoleItemModelSetTransformer);
    }

    listPopulationGroups(): Observable<PopulationGroup[]> {
        return this._http
            .get<PopulationGroup[]>(
                `${this._appConfig.API_ENDPOINTS.USER}/population/population-groups`,
            )
            .pipe(
                catchError((error) => {
                    console.error(error);
                    throw new Error('population-groups failed');
                }),
            );
    }
}
